const TextBaseSize = 1;
const TextScaleRatio = 1.333;
export const FontWeight = {
    light: 300,
    regular: 400,
    bold: 700,
};
export const Typography = {
    xs: `${TextBaseSize / (TextScaleRatio * TextScaleRatio)}rem`,
    sm: `${TextBaseSize / TextScaleRatio}rem`,
    md: `${TextBaseSize}rem`,
    lg: `${TextBaseSize * TextScaleRatio}rem`,
    xl: `${TextBaseSize * TextScaleRatio ** 2}rem`,
    Truncate: `
		overflow: hidden;
		-o-text-overflow: ellipsis;
		text-overflow: ellipsis;
		white-space: nowrap;`,
    NoSelect: `
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		cursor: default;`,
    FontWeight: FontWeight,
    FontFamily: `'Lato', sans-serif`,
    FontFamilyMonospace: `source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace`,
};
export const IndefiniteArticle = (noun) => {
    return ['a', 'e', 'i', 'o', 'u'].indexOf(noun[0].toLowerCase()) !== -1 ? `an ${noun}` : `a ${noun}`;
};
export const Capitalise = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
export const pluralize = (text) => {
    if (!text) {
        return '';
    }
    text = text.toString();
    const lastLetter = text.substr(text.length - 1).toLowerCase();
    const secondLast = text.substring(text.length - 2, text.length - 1).toLowerCase();
    const lastTwoLetters = text.substr(text.length - 2).toLowerCase();
    if (lastLetter === 'y') {
        // if second last word is a vowel just append s
        if (secondLast === 'a' ||
            secondLast === 'e' ||
            secondLast === 'i' ||
            secondLast === 'o' ||
            secondLast === 'u') {
            text += 's';
        }
        else {
            text = text.substring(0, text.length - 1) + 'ies';
        }
        // Need some sort of checking to see if the word needs to be handled
        // differently i.e class
    }
    else if (lastTwoLetters === 'ss') {
        text += 'es';
    }
    else if (lastLetter === 's') {
        // do nothing!
    }
    else {
        text += 's';
    }
    return text;
};
export const LoremIpsum = (words) => {
    const data = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quis metus efficitur, venenatis nunc et, aliquam neque. Aenean et justo vehicula, laoreet leo quis, hendrerit turpis. Quisque ultricies nibh sed laoreet imperdiet. Praesent pretium, neque sit amet feugiat ultrices, erat turpis ultrices mauris, eget porta turpis mauris convallis turpis. Aliquam erat volutpat. Nunc malesuada est et est sollicitudin feugiat eget non tellus. Proin lobortis libero vel tellus sodales hendrerit. In hac habitasse platea dictumst. Aliquam ultricies lobortis vulputate. Nam dapibus orci sapien, id scelerisque nibh tempor et. Nulla eget commodo eros, id viverra tellus. Etiam ac tellus sodales, suscipit magna id, pulvinar sem. Nam in elit ac purus tincidunt fermentum. Vivamus eget gravida sapien. Quisque pulvinar justo nec nibh tincidunt, ac molestie mi accumsan. Donec posuere mi ut commodo porttitor. Donec leo sem, sodales vel condimentum ac, lobortis nec turpis. In tortor dui, convallis eget hendrerit nec, malesuada non massa. Maecenas at arcu massa. Ut rhoncus condimentum eros, sit amet placerat eros convallis eget. In ut facilisis diam, imperdiet ultricies tellus. Nunc sollicitudin justo tincidunt placerat lobortis. Nunc mollis diam sem, sed consequat augue feugiat in. In pellentesque, lacus in ultricies feugiat, nisl erat interdum arcu, quis tristique lacus turpis quis quam. Fusce non risus velit. Praesent id risus vulputate, efficitur magna accumsan, euismod lorem. Quisque tincidunt lectus ac orci lobortis tempus. Quisque ultricies velit ut mauris convallis, at gravida diam luctus. Proin vitae diam orci. Nullam enim mauris, dapibus quis malesuada in, commodo sit amet ex. Quisque et ante at felis pellentesque pellentesque eu sit amet est. Phasellus in est tortor. Sed eu rutrum arcu. Nam interdum luctus turpis, in luctus purus finibus ut. Donec interdum ligula in nulla sollicitudin, vitae luctus neque tristique. Morbi et fringilla leo. Mauris tincidunt ante ac odio ultrices, sed iaculis tortor facilisis. Nunc quis augue faucibus, commodo purus vitae, luctus ex. Proin pulvinar augue vel mi porttitor, a scelerisque justo eleifend. Ut ultrices dui et dolor malesuada, eget imperdiet massa aliquam. Sed nunc lorem, mollis eget imperdiet non, finibus a nulla. Etiam sit amet sem in lacus dignissim auctor et ac purus. Proin suscipit euismod tellus, vel maximus diam ullamcorper volutpat. Proin vulputate justo erat, nec vulputate nulla convallis at. Duis lobortis maximus leo in tristique. Aenean luctus commodo viverra. Ut risus elit, pharetra sit amet tempor a, tempor ac orci. Duis vel lorem sapien. Sed molestie iaculis erat at vehicula.';
    let string = data.split(' ').slice(0, words).join(' ');
    if (string.slice(-1) !== '.') {
        string = string + '.';
    }
    return string;
};
//# sourceMappingURL=Typography.js.map